import { arrayMove } from "@dnd-kit/sortable";
import find from "lodash/find";

import { TableData } from "./table";
import { PaginationOptions, ReactTable, Row } from "./table.types";

export const getPaginationOptions = <TABLE_DATA extends TableData>(
  table: ReactTable<TABLE_DATA>,
  paginationOptions?: PaginationOptions
): PaginationOptions => {
  if (paginationOptions) {
    return paginationOptions;
  }
  return {
    currentPage: table.state.pagination.pageIndex + 1,
    totalPages: table.getPageCount(),
    onClick: (page: number) => table.setPageIndex(page - 1)
  };
};

export const getReorderedTableData = <TABLE_DATA extends TableData>(
  rows: Row<TABLE_DATA>[],
  tableData: TABLE_DATA[],
  activeId: string,
  overId: string
): TABLE_DATA[] | null => {
  const activeRow = find(rows, ["id", activeId]);
  const overRow = find(rows, ["id", overId]);

  if (!activeRow || !overRow) {
    return null;
  }

  const activeIndex = tableData.indexOf(activeRow.original);
  const overIndex = tableData.indexOf(overRow.original);

  if (activeIndex === -1 || overIndex === -1) {
    return null;
  }

  return arrayMove(tableData, activeIndex, overIndex);
};

export const sortingDateFn = (dateA: Date | undefined, dateB: Date | undefined): number =>
  (dateA?.getTime() ?? 0) - (dateB?.getTime() ?? 0);
